/* eslint-disable */
// @ts-ignore
import { Icon } from "@chakra-ui/react";
import {
  MdPerson,
  MdHome,
  MdOutlineHeadsetMic,
  MdOutlineElderly,
  MdAccessible,
  MdMenuBook,
  MdLock,
  MdOutlineWheelchairPickup,
  MdOutlineEngineering,
  MdOutlineGroups,
  MdCheck,
  MdCardMembership,
  MdCardTravel,
  MdSdCard,
  MdCreditCard,
} from "react-icons/md";
import {
  onlyAdmin,
  all,
  supLoja,
  estudante,
  pcd,
  senior,
  seniorConsulta,
  seniorAprovar,
  cadastroPrefeitura,
  atendenteAuditoria,
} from "variables/charts";
// Admin Imports
import DashboardsDefault from "views/admin/dashboards/default";
import CustomerProfile from "views/admin/atendimento/profile";
import ConsultaCartaoAvulso from "views/admin/atendimento/consultaAvulso";
import LoginScreen from "views/auth/signIn";
import ForgotPassword from "views/auth/forgotPassword";

// Main Imports
import AccountSenior from "views/admin/gratuidade/senior";
import AccountSeniorAprovar from "views/admin/gratuidade/aprovacaoSenior/index";
import AccountPcd from "views/admin/gratuidade/pcd";
import AccountEstudante from "views/admin/gratuidade/estudante";
import { IsNotEmpty } from "config/functions";

let pathsMap: any = {};
let filteredRoutes: any = [];
let routes: any = [];
let recoverLoggedUser = JSON.parse(localStorage.getItem("user"));

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("stayLogged");
  localStorage.removeItem(".");
  if (!isLoginPage()) {
    window.location.href = "/atendimento#/auth/sign-in";
    window.location.reload();
  }
};

const INACTIVITY_LIMIT_KEY = "inactivityLimit";
const LAST_ACTIVITY_KEY = "lastActivityTimestamp";

function isLoginPage(): boolean {
  return window.location.href.includes("/auth/sign-in");
}

const INACTIVITY_LIMIT = 8 * 60 * 60 * 1000;
localStorage.setItem(INACTIVITY_LIMIT_KEY, INACTIVITY_LIMIT.toString());

let inactivityTimer: ReturnType<typeof setTimeout> | undefined;

function updateLastActivity(): void {
  const now = Date.now();
  localStorage.setItem(LAST_ACTIVITY_KEY, now.toString());
}

function startInactivityTimer(timeout: number): void {
  if (inactivityTimer !== undefined) {
    clearTimeout(inactivityTimer);
  }

  inactivityTimer = setTimeout(() => {
    logout();
  }, timeout);
}

function checkInactivityOnLoad(): void {
  const lastActivityStr = localStorage.getItem(LAST_ACTIVITY_KEY);

  if (lastActivityStr) {
    const lastActivity = parseInt(lastActivityStr, 10);
    const now = Date.now();
    const elapsed = now - lastActivity;

    if (elapsed >= INACTIVITY_LIMIT) {
      logout();
    } else {
      startInactivityTimer(INACTIVITY_LIMIT - elapsed);
    }
  } else {
    updateLastActivity();
    startInactivityTimer(INACTIVITY_LIMIT);
  }
}

function handleUserActivity(): void {
  updateLastActivity();
  startInactivityTimer(INACTIVITY_LIMIT);
}

const activityEvents: (keyof WindowEventMap)[] = [
  "mousemove",
  "keydown",
  "mousedown",
  "touchstart",
  "scroll",
];

activityEvents.forEach((eventName) => {
  window.addEventListener(eventName, handleUserActivity, { passive: true });
});

checkInactivityOnLoad();

if (window.config.tenant !== "macae") {
  if (IsNotEmpty(recoverLoggedUser)) {
    if (estudante.some((perfil) => recoverLoggedUser.perfis.includes(perfil))) {
      var perfilEstudante = recoverLoggedUser.perfis;
      recoverLoggedUser.perfis.map((perfil: any) => {
        if (perfil === "CONSULTA_ESTUDANTE") {
          routes.push(
            {
              name: "Estudante",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: estudante,
              items: [
                {
                  name: "Consulta",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: estudante,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        } else if (
          perfil === "CADASTRO_ESTUDANTE" ||
          perfil === "SUPERVISOR_ESTUDANTE"
        ) {
          routes.push(
            {
              name: "Estudante",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: estudante,
              items: [
                {
                  name: "Consulta",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: estudante,
                },
                {
                  name: "Cadastrar benefício",
                  layout: "/admin",
                  path: "/gratuidade/estudante",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountEstudante,
                  allowedProfiles: estudante,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
      });
    }
    if (pcd.some((perfil) => recoverLoggedUser.perfis.includes(perfil))) {
      var perfilPcd = recoverLoggedUser.perfis;
      recoverLoggedUser.perfis.map((perfil: any) => {
        if (perfil === "CONSULTA_PCD") {
          routes.push(
            {
              name: "PCD / DC",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: pcd,
              items: [
                {
                  name: "Consultar",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: pcd,
                },
                {
                  name: "Login",
                  layout: "/auth",
                  path: "/sign-in",
                  icon: (
                    <Icon
                      as={MdLock}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: LoginScreen,
                  allowedProfiles: [],
                },
                {
                  name: "Esqueci a senha",
                  layout: "/auth/recuperar/atendimento",
                  path: "/forgot-password",
                  icon: (
                    <Icon
                      as={MdLock}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: ForgotPassword,
                  allowedProfiles: [],
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
        if (perfil === "SUPERVISOR_PCD") {
          routes.push(
            {
              name: "PCD / DC",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: pcd,
              items: [
                {
                  name: "Consultar",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: pcd,
                },
                {
                  name: "Cadastrar benefício",
                  layout: "/admin",
                  path: "/gratuidade/pcd",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountPcd,
                  allowedProfiles: pcd,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
        if (perfil === "CADASTRO_PCD") {
          routes.push(
            {
              name: "PCD / DC",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: pcd,
              items: [
                {
                  name: "Cadastrar benefício",
                  layout: "/admin",
                  path: "/gratuidade/pcd",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountPcd,
                  allowedProfiles: pcd,
                },
                {
                  name: "Esqueci a senha",
                  layout: "/auth/recuperar/atendimento",
                  path: "/forgot-password",
                  icon: (
                    <Icon
                      as={MdLock}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: ForgotPassword,
                  allowedProfiles: [],
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
        if (perfil === "MEDICO_PCD") {
          routes.push(
            {
              name: "PCD / DC",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: pcd,
              items: [
                {
                  name: "Cadastrar benefício",
                  layout: "/admin",
                  path: "/gratuidade/pcd",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountPcd,
                  allowedProfiles: pcd,
                },
                {
                  name: "Esqueci a senha",
                  layout: "/auth/recuperar/atendimento",
                  path: "/forgot-password",
                  icon: (
                    <Icon
                      as={MdLock}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: ForgotPassword,
                  allowedProfiles: [],
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
      });
    }
    if (senior.some((perfil) => recoverLoggedUser.perfis.includes(perfil))) {
      var perfilSenior = recoverLoggedUser.perfis;
      recoverLoggedUser.perfis.map((perfil: any) => {
        if (perfil === "CONSULTA_SENIOR") {
          routes.push(
            {
              name: "Senior",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: senior,
              items: [
                {
                  name: "Consulta",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: senior,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        } else if (perfil === "CADASTRO_SENIOR") {
          routes.push(
            {
              name: "Sênior",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: senior,
              items: [
                {
                  name: "Cadastrar benefício",
                  layout: "/admin",
                  path: "/gratuidade/senior",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountSenior,
                  allowedProfiles: senior,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        } else if (perfil === "SUPERVISOR_SENIOR") {
          routes.push(
            {
              name: "Sênior",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: senior,
              items: [
                {
                  name: "Consultar",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: seniorConsulta,
                },
                {
                  name: "Cadastrar benefício",
                  layout: "/admin",
                  path: "/gratuidade/senior",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountSenior,
                  allowedProfiles: senior,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
      });
    }
    if (
      cadastroPrefeitura.some((perfil) =>
        recoverLoggedUser.perfis.includes(perfil)
      )
    ) {
      var perfilCadastroPrefeitura = recoverLoggedUser.perfis;
      recoverLoggedUser.perfis.map((perfil: any) => {
        if (perfil === "CADASTRO_PREFEITURA") {
          routes.push(
            {
              name: "Prefeitura",
              path: "/atendimento",
              icon: (
                <Icon
                  as={MdOutlineHeadsetMic}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              collapse: true,
              allowedProfiles: cadastroPrefeitura,
              items: [
                {
                  name: "Cliente",
                  layout: "/admin",
                  path: "/atendimento/profile",
                  icon: (
                    <Icon
                      as={MdPerson}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: CustomerProfile,
                  allowedProfiles: cadastroPrefeitura,
                },
              ],
            },
            {
              name: "Login",
              layout: "/auth",
              path: "/sign-in",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: LoginScreen,
              allowedProfiles: [],
            },
            {
              name: "Esqueci a senha",
              layout: "/auth/recuperar/atendimento",
              path: "/forgot-password",
              icon: (
                <Icon as={MdLock} width="20px" height="20px" color="inherit" />
              ),
              component: ForgotPassword,
              allowedProfiles: [],
            }
          );
        }
      });
    }
    if (all.some((perfil) => recoverLoggedUser.perfis.includes(perfil))) {
      routes = [];
      routes.push(
        {
          name: "Dashboard",
          layout: "/admin",
          path: "/dashboard",
          icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
          component: DashboardsDefault,
          allowedProfiles: all,
        },
        {
          name: "Atendimento",
          path: "/atendimento",
          icon: (
            <Icon
              as={MdOutlineHeadsetMic}
              width="20px"
              height="20px"
              color="green"
            />
          ),
          collapse: true,
          allowedProfiles: all,
          items: [
            {
              name: "Cliente",
              layout: "/admin",
              path: "/atendimento/profile",
              icon: (
                <Icon
                  as={MdPerson}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              component: CustomerProfile,
              allowedProfiles: all,
            },
            {
              name: "Consulta Avulso",
              layout: "/admin",
              path: "/atendimento/cartaoAvulso",
              icon: (
                <Icon
                  as={MdCreditCard}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              component: ConsultaCartaoAvulso,
              allowedProfiles: all,
            },
            {
              name: "Gratuidades",
              path: "/main",
              icon: (
                <Icon
                  as={MdOutlineWheelchairPickup}
                  width="20px"
                  height="20px"
                  color="yellow.500"
                />
              ),
              collapse: true,
              allowedProfiles: all,
              items: [
                {
                  name: "Sênior",
                  path: "/main",
                  icon: (
                    <Icon
                      as={MdOutlineWheelchairPickup}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  collapse: true,
                  allowedProfiles: all,
                  items: [
                    {
                      name: "Atendimento",
                      layout: "/admin",
                      path: "/gratuidade/senior",
                      icon: (
                        <Icon
                          as={MdOutlineElderly}
                          width="20px"
                          height="20px"
                          color="inherit"
                        />
                      ),
                      component: AccountSenior,
                      allowedProfiles: all,
                    },
                    {
                      name: "Pendente aprovação",
                      layout: "/admin",
                      path: "/gratuidade/aprovacaoSenior",
                      icon: (
                        <Icon
                          as={MdCheck}
                          width="20px"
                          height="20px"
                          color="inherit"
                        />
                      ),
                      component: AccountSeniorAprovar,
                      allowedProfiles: seniorAprovar,
                    },
                  ],
                },
                {
                  name: "PCD / DC",
                  layout: "/admin",
                  path: "/gratuidade/pcd",
                  icon: (
                    <Icon
                      as={MdAccessible}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountPcd,
                  allowedProfiles: all,
                },
                {
                  name: "Estudante",
                  layout: "/admin",
                  path: "/gratuidade/estudante",
                  icon: (
                    <Icon
                      as={MdMenuBook}
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                  ),
                  component: AccountEstudante,
                  allowedProfiles: all,
                },
              ],
            },
          ],
        },

        {
          name: "Login",
          layout: "/auth",
          path: "/sign-in",
          icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
          component: LoginScreen,
          allowedProfiles: [],
        },
        {
          name: "Esqueci a senha",
          layout: "/auth/recuperar/atendimento",
          path: "/forgot-password",
          icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
          component: ForgotPassword,
          allowedProfiles: [],
        }
      );
    } else if (
      atendenteAuditoria.some((perfil) =>
        recoverLoggedUser.perfis.includes(perfil)
      )
    ) {
      routes = [];
      routes.push(
        {
          name: "Dashboard",
          layout: "/admin",
          path: "/dashboard",
          icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
          component: DashboardsDefault,
          allowedProfiles: atendenteAuditoria,
        },
        {
          name: "Atendimento",
          path: "/atendimento",
          icon: (
            <Icon
              as={MdOutlineHeadsetMic}
              width="20px"
              height="20px"
              color="green"
            />
          ),
          collapse: true,
          allowedProfiles: atendenteAuditoria,
          items: [
            {
              name: "Cliente",
              layout: "/admin",
              path: "/atendimento/profile",
              icon: (
                <Icon
                  as={MdPerson}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              component: CustomerProfile,
              allowedProfiles: atendenteAuditoria,
            },
          ],
        },

        {
          name: "Login",
          layout: "/auth",
          path: "/sign-in",
          icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
          component: LoginScreen,
          allowedProfiles: [],
        },
        {
          name: "Esqueci a senha",
          layout: "/auth/recuperar/atendimento",
          path: "/forgot-password",
          icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
          component: ForgotPassword,
          allowedProfiles: [],
        }
      );
    }
  } else {
    routes.push(
      {
        name: "Dashboard",
        layout: "/admin",
        path: "/dashboard",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: DashboardsDefault,
        allowedProfiles: all,
      },
      {
        name: "Atendimento",
        path: "/atendimento",
        icon: (
          <Icon
            as={MdOutlineHeadsetMic}
            width="20px"
            height="20px"
            color="inherit"
          />
        ),
        collapse: true,
        allowedProfiles: all,
        items: [
          {
            name: "Cliente",
            layout: "/admin",
            path: "/atendimento/profile",
            icon: (
              <Icon as={MdPerson} width="20px" height="20px" color="inherit" />
            ),
            component: CustomerProfile,
            allowedProfiles: all,
          },
          {
            name: "Gratuidades",
            path: "/main",
            icon: (
              <Icon
                as={MdOutlineWheelchairPickup}
                width="20px"
                height="20px"
                color="inherit"
              />
            ),
            collapse: true,
            allowedProfiles: all,
            items: [
              {
                name: "Senior",
                layout: "/admin",
                path: "/gratuidade/senior",
                icon: (
                  <Icon
                    as={MdOutlineElderly}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: AccountSenior,
                allowedProfiles: all,
              },
              {
                name: "PCD / DC",
                layout: "/admin",
                path: "/gratuidade/pcd",
                icon: (
                  <Icon
                    as={MdAccessible}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: AccountPcd,
                allowedProfiles: all,
              },
              {
                name: "Estudante",
                layout: "/admin",
                path: "/gratuidade/estudante",
                icon: (
                  <Icon
                    as={MdMenuBook}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: AccountEstudante,
                allowedProfiles: all,
              },
            ],
          },
        ],
      },

      {
        name: "Login",
        layout: "/auth",
        path: "/sign-in",
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
        component: LoginScreen,
        allowedProfiles: [],
      },
      {
        name: "Esqueci a senha",
        layout: "/auth/recuperar/atendimento",
        path: "/forgot-password",
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
        component: ForgotPassword,
        allowedProfiles: [],
      }
    );
  }
} else {
  routes.push(
    {
      name: "Dashboard",
      layout: "/admin",
      path: "/dashboard",
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: DashboardsDefault,
      allowedProfiles: all,
    },
    {
      name: "Atendimento",
      path: "/atendimento",
      icon: (
        <Icon
          as={MdOutlineHeadsetMic}
          width="20px"
          height="20px"
          color="inherit"
        />
      ),
      collapse: true,
      allowedProfiles: all,
      items: [
        {
          name: "Estudante",
          layout: "/admin",
          path: "/atendimento/profile",
          icon: (
            <Icon as={MdPerson} width="20px" height="20px" color="inherit" />
          ),
          component: CustomerProfile,
          allowedProfiles: all,
        },
      ],
    },

    {
      name: "Login",
      layout: "/auth",
      path: "/sign-in",
      icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
      component: LoginScreen,
      allowedProfiles: [],
    },
    {
      name: "Esqueci a senha",
      layout: "/auth/recuperar/atendimento",
      path: "/forgot-password",
      icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
      component: ForgotPassword,
      allowedProfiles: [],
    }
  );
}
// Função para filtrar e adicionar apenas itens com nomes diferentes
const getUniqueItems = (routes: any[]) => {
  const uniqueItems: any[] = [];

  routes.forEach((route) => {
    if (Array.isArray(route.items)) {
      route.items.forEach((item: any) => {
        const exists = uniqueItems.some(
          (uniqueItem) => uniqueItem.name === item.name
        );
        if (!exists) {
          uniqueItems.push(item);
        }
      });
    }
  });

  return uniqueItems;
};

// Obtenha os itens únicos para todas as rotas
const uniqueItems: any[] = getUniqueItems(routes);

routes.forEach((route: any) => {
  if (!pathsMap[route.path]) {
    pathsMap[route.path] = route;
  } else {
    // Se o path já existe, compare o número de itens, o perfil que tem mais itens é
    // geralmente supervisor ou administrador, esses dão bypass nos perfis menores que tem menos item
    const existingRoute = pathsMap[route.path];
    if (
      existingRoute.items &&
      route.items &&
      route.items.length > existingRoute.items.length
    ) {
      pathsMap[route.path] = route;
    }
  }
});

if (pathsMap["/atendimento"]) {
  pathsMap["/atendimento"].items = []; // Exclui todos os itens existentes
  pathsMap["/atendimento"].items.push(...uniqueItems); // Adiciona os novos itens
}

routes = Object.values(pathsMap);
export default routes;
